import type { InboxRulesEditOptionState } from "../../store/schema/InboxRulesEditOptionState";
export default function initializeInboxRulesEditState(): InboxRulesEditOptionState {
    return {
        saveStrategy: "default",
        ruleId: "",
        ruleName: "",
        conditionalClauseIds: [],
        actionClauseIds: [],
        exceptionClauseIds: [],
        clauseMap: new Map(),
        clauseErrorTextMap: new Map(),
        includesWordsInputTextMap: new Map(),
        isSectionInfoCalloutVisible: new Map(),
        focusedClauseId: "",
        ignoreSubsequentRules: true,
        shouldRunRuleNow: false,
        selectedFolderId: "",
        shouldShowMoveToDropdown: true,
        fromGroupCalloutClauses: [],
        fromDLWarningClauses: [],
        clauseIdToFocus: "",
        addClauseButtonToFocus: null,
        shouldDisableSaveButton: false,
        shouldFocusActionMoveToClause: false,
        isAuthenticationRequired: false,
    };
}
